export default __webpack_public_path__ + "static/loading_product_icon_bag-86f926295f0060f3b79e5ec91c764666.png";